(() => {
  const root = document.documentElement;
  const welcome = document.querySelector('[data-rarestate-welcome]');

  if (!welcome || !root.classList.contains('rarestate-intro-pending')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration = reducedMotion ? 2200 : 3400;
  let closing = false;

  const rememberIntro = () => {
    try {
      window.sessionStorage.setItem('rare-state:intro-seen', 'true');
    } catch (_error) {
      // Storage can be unavailable in private browsing; the intro still works.
    }
  };

  const finish = () => {
    if (closing) return;
    closing = true;
    rememberIntro();
    root.classList.remove('rarestate-intro-playing');
    root.classList.add('rarestate-intro-leaving');

    window.setTimeout(() => {
      root.classList.remove('rarestate-intro-pending', 'rarestate-intro-leaving');
      welcome.remove();
    }, reducedMotion ? 200 : 650);
  };

  welcome.querySelector('[data-rarestate-welcome-skip]')?.addEventListener('click', finish);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') finish();
  });

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => root.classList.add('rarestate-intro-playing'));
  });

  window.setTimeout(finish, duration);
})();
